export const isPropertyChangeMaker = (request, reviewer) => (
  request?.proposed_by_user_id != null
  && reviewer?.id != null
  && String(request.proposed_by_user_id) === String(reviewer.id)
);

export const validateRegistryChangeReason = (value, label = 'Reason') => {
  const reason = String(value || '').trim();
  if (reason.length < 3) return `${label} must be at least 3 characters.`;
  if (reason.length > 2000) return `${label} cannot exceed 2,000 characters.`;
  return '';
};

export const interestSnapshotKey = (interest, index = 0) => [
  interest?.party_uid || 'unknown-party',
  interest?.interest_type || 'unknown-interest',
  index,
].join(':');

export const shortPartyUid = value => {
  const uid = String(value || '').trim();
  if (!uid) return 'Unknown Party';
  return uid.length > 18 ? `${uid.slice(0, 8)}…${uid.slice(-6)}` : uid;
};
